import { format, parseISO } from 'date-fns';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { Button, Col, Container, Row } from 'react-bootstrap';
import { useLocation, useRouteMatch } from 'react-router';
import { useHistory, Link } from 'react-router-dom';
import { FaPrint, FaSpinner, FaTrashAlt } from 'react-icons/fa';
import { IPacienteMaisCartaoDTO } from '../../components/Agendamento';
import Loading from '../../components/Loading';
import PacienteCabecalho, {
  IInfoCartao,
} from '../../components/PacienteCabecalho';
import SelectSync, { IOption } from '../../components/SelectSync';
import { useClinica } from '../../hooks/clinica';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import {
  formataCPF,
  formataIdade,
  formataTelefone,
  formatPrice,
  STATUS_AGENDA,
  TIPO_TRATAMENTO,
} from '../../utils/funcoes';
import getResponseErrors from '../../utils/getResponseErrors';
import { ITratamento } from '../ListaOrcamentos';
import { IPacienteCodigo } from '../PacienteAtendimento';
import AgendamentosTratamento from '../PacienteAtendimento/Odonto/AgendamentosTratamento';
import { IOrcamento } from '../PacienteAtendimento/Odonto';
import { Spinner } from '../../components/Agendamento/styles';
import SelectAsync from '../../components/SelectAsync';
import { useAuth } from '../../hooks/auth';

// import { Container } from './styles';

interface IUrlParams {
  id: string;
}

interface IPropsLocation {
  paciente: IPacienteMaisCartaoDTO;
}

interface IContrato {
  ConCodigo: number;
  ConContrato: string;
  ConAssinado: boolean;
  ConArquivo: string;
  ConExternalId: string;
}
export interface IPacoteRegras {
  PrgCodigo: number;
  PrgDescricao: string;
  PrgPerCodigo: number;
  PrgProCodigo: number;
  PrgLimiteSemanal: number;
  PrgLimiteMensal: number;
  PrgLimiteDias: number;
  PrgValor: number;
  PrgValorPlano: number;
  created_at: Date;
  ProNome: string;
  ProValor: number;
}

interface IRetornoBuscaPacotesCombo {
  options: {
    value: string;
    label: string;
  }[];
  pacotes: IPacoteRegras[];
}

const PacoteTratamento: React.FC = () => {
  const location = useLocation();
  const { addToast } = useToast();
  const { imagensClinica } = useClinica();
  const { user } = useAuth();
  const history = useHistory();
  const { params } = useRouteMatch<IUrlParams>();
  const formRefPaciente = useRef<FormHandles>(null);

  const { id } = params;

  const { paciente } = location.state as IPropsLocation;

  const [pacienteResponsavelID, setPacienteResponsavelID] = useState<
    number | undefined
  >(paciente?.PacCodigo);

  const [pacienteResponsavel, setPacienteResponsavel] = useState<
    IPacienteCodigo | undefined
  >(undefined);

  const [optionsPacotes, setOptionsPacotes] = useState<IOption[] | undefined>(
    undefined,
  );
  const [pacotes, setPacotes] = useState<IPacoteRegras[] | undefined>(
    undefined,
  );

  const [pacoteSelecionado, setPacoteSelecionado] = useState<
    IPacoteRegras | undefined
  >(undefined);

  const [tratamento, setTratamento] = useState<ITratamento | undefined>(
    undefined,
  );

  const [orcamentoAlterado, setOrcamentoAlterado] = useState(true);

  const [cartao, setCartao] = useState<IInfoCartao | undefined>({
    possuiCartao: paciente?.possuiCartao,
    parcelas: paciente?.cartao[0]?.Parcelas?.toString(),
    Status: paciente?.cartao[0]?.Status,
    PlaCodigo: paciente?.cartao[0]?.PlaCodigo,
  });

  const semFoto =
    imagensClinica.find(img => img.nome === 'semFoto')?.arquivo_url || '';

  const [pacienteSelecionado, setPacienteSelecionado] = useState<
    IPacienteCodigo | undefined
  >(
    paciente
      ? {
          ...paciente,
          PacTelefone: formataTelefone(paciente.PacTelefone),
          PacCelular: formataTelefone(paciente.PacCelular),
          PacCPF: formataCPF(paciente.PacCPF),
          PacDataNascFormatada: format(
            parseISO(paciente.PacDataNasc),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(paciente.PacDataNasc)),
          avatar_url: paciente.avatar_url || semFoto,
        }
      : undefined,
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadPacotes(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IRetornoBuscaPacotesCombo>(
          `pacoteregras/comboPacote`,
        );

        setOptionsPacotes(response.data.options);
        setPacotes(response.data.pacotes);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar Pedido de Exames',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    if (!optionsPacotes) loadPacotes();
  }, [optionsPacotes, addToast]);

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`/tratamento/${id}`);
        const responseTratamento: ITratamento = response.data;

        const agendamentosTratamento = responseTratamento.agendamentosTratamento.filter(
          age => age.agenda.AgeStatus >= STATUS_AGENDA.AGENDADO,
        );

        const tratamentoFormatado = {
          ...responseTratamento,
          dataFormatada: format(
            parseISO(responseTratamento.created_at.toString()),
            'dd/MM/yyyy',
          ),
          // tipoFormatado: TIPO_TRATAMENTO_NOME[responseTratamento.tipo],
          valorFormatado: formatPrice(responseTratamento.valor),
          statusFormatado: responseTratamento.finalizado ? 'Sim' : 'Não',
          agendamentosTratamento,
        };

        setPacienteResponsavelID(tratamentoFormatado.PacCodigoResponsavel);

        const responsePaciente = await api.get<IPacienteMaisCartaoDTO>(
          `/pacientes/pacientemaiscartao/${tratamentoFormatado.PacCodigo}`,
        );

        setCartao({
          possuiCartao: responsePaciente.data?.possuiCartao,
          parcelas: responsePaciente.data?.cartao[0]?.Parcelas?.toString(),
          Status: responsePaciente.data?.cartao[0]?.Status,
          PlaCodigo: responsePaciente.data?.cartao[0]?.PlaCodigo,
        });
        setPacienteSelecionado({
          ...responsePaciente.data,
          PacTelefone: formataTelefone(responsePaciente.data.PacTelefone),
          PacCelular: formataTelefone(responsePaciente.data.PacCelular),
          PacCPF: formataCPF(responsePaciente.data.PacCPF),
          PacDataNascFormatada: format(
            parseISO(responsePaciente.data.PacDataNasc),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(responsePaciente.data.PacDataNasc)),
          avatar_url: responsePaciente.data.avatar_url || semFoto,
        });

        setPacoteSelecionado(
          pacotes?.find(pac => pac.PrgCodigo === tratamentoFormatado.PrgCodigo),
        );
        setTratamento(tratamentoFormatado);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar Pedido de Exames',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }

    if (id && semFoto !== '' && pacotes) loadDados();
  }, [addToast, id, semFoto, pacotes]);

  const temResponsavel = useMemo(() => {
    return tratamento && tratamento.PacCodigo !== pacienteResponsavelID;
  }, [tratamento, pacienteResponsavelID]);

  useEffect(() => {
    async function loadDadosReponsavel(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`/pacientes/${pacienteResponsavelID}`);
        const responsePaciente: IPacienteCodigo = response.data;

        setPacienteResponsavel({
          ...responsePaciente,
          PacTelefone: formataTelefone(responsePaciente.PacTelefone),
          PacCelular: formataTelefone(responsePaciente.PacCelular),
          PacCPF: formataCPF(responsePaciente.PacCPF),
          PacDataNascFormatada: format(
            parseISO(responsePaciente.PacDataNasc),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(responsePaciente.PacDataNasc)),
          avatar_url: responsePaciente.avatar_url,
        });
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o responsável',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (temResponsavel) loadDadosReponsavel();
  }, [temResponsavel, addToast, pacienteResponsavelID]);

  const handleSubmitPacote = useCallback(() => {
    console.log('foi');
  }, []);

  const handleSelectPacoteChange = useCallback(
    ({ value }) => {
      if (value && value !== '') {
        setPacoteSelecionado(
          pacotes?.find(pac => pac.PrgCodigo === Number(value)),
        );
        setOrcamentoAlterado(true);
      }
    },
    [pacotes],
  );

  const handleAddTratamento = useCallback(async () => {
    if (!pacoteSelecionado) {
      addToast({ type: 'info', title: 'Nenhum pacote selecionado' });
      return;
    }
    setLoading(true);
    try {
      const dadosTratamento = {
        PacCodigo: pacienteSelecionado?.PacCodigo,
        tipo: TIPO_TRATAMENTO.PACOTE,
        valor: pacoteSelecionado.PrgValor,
        secoes: pacoteSelecionado.PrgLimiteMensal,
        plano: cartao?.possuiCartao,
        PrgCodigo: pacoteSelecionado.PrgCodigo,
        PacCodigoResponsavel:
          pacienteResponsavelID || pacienteSelecionado?.PacCodigo || 0,
      };

      const dadosProcedimentos = {
        dente: pacoteSelecionado.ProNome,
        ProCodigo: pacoteSelecionado.PrgProCodigo,
        ProNome: pacoteSelecionado.ProNome,
        valor: pacoteSelecionado.PrgValor,
      };

      if (!tratamento) {
        const response = await api.post<ITratamento>(`/tratamento/pacote`, {
          ...dadosTratamento,
          procedimentosTratamento: [dadosProcedimentos],
        });

        const orcamentoFormatado = {
          ...response.data,
          dataFormatada: format(
            parseISO(response.data.created_at.toString()),
            'dd/MM/yyyy',
          ),
          // tipoFormatado: TIPO_TRATAMENTO_NOME[response.data.tipo],
          valorFormatado: formatPrice(response.data.valor),
          statusFormatado: response.data.finalizado ? 'Sim' : 'Não',
        };

        setTratamento(orcamentoFormatado);
      } else {
        const responseUpdate = await api.put<IOrcamento>(
          `/tratamento/pacote/${tratamento.id}`,
          {
            ...dadosTratamento,
            id: tratamento.id,
            procedimentosTratamento: [dadosProcedimentos],
          },
        );
        setTratamento({
          ...tratamento,
          ...dadosTratamento,
          ...responseUpdate.data,
          tipo: tratamento.tipo,
        });
      }

      setOrcamentoAlterado(false);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Erro ao salvar Orçamento/Tratamento',
        type: 'error',
        description: mensagemErro,
        timeAlive: 10000,
      });
    } finally {
      setLoading(false);
    }
  }, [
    tratamento,
    addToast,
    cartao,
    pacienteSelecionado?.PacCodigo,
    pacoteSelecionado,
    pacienteResponsavelID,
  ]);

  const handleFecharContrato = useCallback(async () => {
    setLoading(true);
    try {
      const responseContrato = await api.put<IContrato>(
        `/tratamento/${tratamento?.id}/geraContrato`,
        {
          ConOrigem: 2, // pacote
        },
      );
      setTratamento(state => {
        return (
          state && {
            ...state,
            contrato: responseContrato.data,
            orcamento: false,
          }
        );
      });
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Erro ao salvar Gerar Contrato',
        type: 'error',
        description: mensagemErro,
        timeAlive: 10000,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, tratamento]);

  const contrato = useMemo(() => {
    return tratamento?.contrato;
  }, [tratamento?.contrato]);

  const handleSubmitPaciente = useCallback(() => {
    console.log('foi');
  }, []);

  const handleSelectClienteChange = useCallback(({ value, label }) => {
    if (value && value !== '') {
      setPacienteResponsavelID(Number(value));
      setOrcamentoAlterado(true);
    }
  }, []);

  const agendamentos = useMemo(() => {
    if (!tratamento?.agendamentosTratamento)
      return { atendidos: false, agendas: [] };
    return {
      agendas: tratamento.agendamentosTratamento.map(age => {
        return age.agenda;
      }),
      atendidos:
        tratamento.agendamentosTratamento &&
        tratamento.agendamentosTratamento.filter(
          ages => ages.agenda.AgeStatus !== STATUS_AGENDA.ATENDIDO,
        ).length === 0,
    };
  }, [tratamento]);

  const handleDelete = useCallback(async () => {
    if (id) {
      try {
        setLoading(true);

        await api.delete(`/tratamento/${id}`);
        history.push('/tratamentos');
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível buscar os dados',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
  }, [addToast, id, history]);

  return (
    <>
      {loading && <Loading />}
      <Container fluid className="mt-2">
        <div className="mb-2 p-2 bg-white border rounded">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h6 id="topoBusca">Dados Paciente</h6>
            <Button
              type="button"
              variant="outline-primary"
              size="sm"
              onClick={() => history.push('/tratamentos')}
            >
              Voltar para orçamentos
            </Button>
          </div>
          {pacienteSelecionado && (
            <PacienteCabecalho
              paciente={pacienteSelecionado}
              exibeInfoCartao
              exibeEditar
              pacienteID={pacienteSelecionado.PacCodigo}
              cartao={cartao}
            />
          )}
        </div>
        <div className="mb-2 p-2 bg-white border rounded">
          <Row>
            <Col md={7} lg={7}>
              <div className="mb-2 p-2 border rounded">
                <b style={{ marginBottom: '4px', display: 'block' }}>
                  Pacote de Tratamento
                </b>
                <Row>
                  {optionsPacotes &&
                    ((id && pacoteSelecionado) || !id) &&
                    !contrato && (
                      <Col md={12} lg={12}>
                        {loading && <Loading backgroundBlack={false} />}
                        <Form
                          ref={formRefPaciente}
                          style={{ padding: '.5rem' }}
                          onSubmit={handleSubmitPacote}
                          initialData={{
                            prgCodigo: pacoteSelecionado?.PrgCodigo.toString(),
                          }}
                        >
                          <SelectSync
                            name="prgCodigo"
                            label="Selecione o pacote"
                            handleSelectChange={handleSelectPacoteChange}
                            options={optionsPacotes}
                            isDisabled={!!contrato}
                          />
                        </Form>
                      </Col>
                    )}
                </Row>
                <Row className="pl-2">
                  {pacoteSelecionado && !contrato && (
                    <Col md={12} lg={12} className="mt-2">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td>Descrição:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgDescricao}</b>
                            </td>

                            <td>Limite Semanal:</td>
                            <td>
                              <b>
                                {pacoteSelecionado.PrgLimiteSemanal} sessões
                              </b>
                            </td>
                          </tr>

                          <tr>
                            <td>Valor Particular:</td>
                            <td>
                              <b>{formatPrice(pacoteSelecionado.PrgValor)}</b>
                            </td>
                            <td>Total:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgLimiteMensal} sessões</b>
                            </td>
                          </tr>

                          <tr>
                            <td>Valor Plano:</td>

                            <td>
                              <b>
                                {formatPrice(pacoteSelecionado.PrgValorPlano)}
                              </b>
                            </td>

                            <td>Duração:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgLimiteDias} dias</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  )}

                  {tratamento && pacoteSelecionado && contrato && (
                    <Col md={12} lg={12} className="mt-2">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td>Pacote Contratado:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgDescricao}</b>
                            </td>

                            <td>Limite Semanal:</td>
                            <td>
                              <b>
                                {pacoteSelecionado.PrgLimiteSemanal} sessões
                              </b>
                            </td>
                          </tr>

                          <tr>
                            <td>Plano:</td>
                            <td>
                              <b>{tratamento.plano ? 'Sim' : 'Não'}</b>
                            </td>
                            <td>Total:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgLimiteMensal} sessões</b>
                            </td>
                          </tr>

                          <tr>
                            <td>Valor:</td>

                            <td>
                              <b>
                                {tratamento.plano
                                  ? formatPrice(pacoteSelecionado.PrgValorPlano)
                                  : formatPrice(pacoteSelecionado.PrgValor)}
                              </b>
                            </td>

                            <td>Duração:</td>
                            <td>
                              <b>{pacoteSelecionado.PrgLimiteDias} dias</b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col>
                    <Button
                      type="button"
                      style={{ marginTop: '21px' }}
                      variant="info"
                      onClick={() => handleAddTratamento()}
                      disabled={loading || !orcamentoAlterado}
                      className={`${
                        contrato ||
                        tratamento?.orcamento === false ||
                        !optionsPacotes ||
                        optionsPacotes.length === 0
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      {loading ? (
                        <Spinner>
                          <FaSpinner />
                        </Spinner>
                      ) : (
                        'Salvar Orçamento'
                      )}
                    </Button>
                  </Col>
                  <Col>
                    {pacoteSelecionado && !contrato && (
                      <div
                        style={{
                          marginTop: '21px',
                          display: 'flex',
                          justifyContent: 'center',
                          color: 'red',
                          fontSize: '18px',
                        }}
                      >
                        <span>
                          {' '}
                          Valor à Pagar:{' '}
                          <b>
                            {cartao?.possuiCartao && cartao.Status === 'Em Dia'
                              ? formatPrice(pacoteSelecionado.PrgValorPlano)
                              : formatPrice(pacoteSelecionado.PrgValor)}
                          </b>
                        </span>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={5} lg={5}>
              <div className="bg-white border rounded p-2 ">
                <b style={{ marginBottom: '4px', display: 'block' }}>
                  Responsável pelo contrato
                </b>
                {!temResponsavel && (
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>O próprio</td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {temResponsavel && pacienteResponsavel && (
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>Nome:</td>
                        <td>
                          <b>{pacienteResponsavel.PacNome}</b>
                        </td>
                      </tr>
                      <tr>
                        <td>CPF:</td>
                        <td>
                          <b>{pacienteResponsavel.PacCPF}</b>
                        </td>
                      </tr>
                      <tr>
                        <td>Telefone:</td>
                        <td>
                          <b>
                            {formataTelefone(pacienteResponsavel.PacTelefone)}
                            {formataTelefone(pacienteResponsavel.PacCelular)}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
                {tratamento?.orcamento && (
                  <>
                    {loading && <Loading backgroundBlack={false} />}
                    <Form
                      ref={formRefPaciente}
                      style={{ padding: '.5rem' }}
                      onSubmit={handleSubmitPaciente}
                    >
                      <SelectAsync
                        name="pacienteResponsavelID"
                        label=""
                        urlApi="pacientes/combo?termoBusca="
                        placeholder="Digite para buscar"
                        handleSelectChange={handleSelectClienteChange}
                      />
                    </Form>
                  </>
                )}
              </div>

              <div className="p-2 ">
                <Row className="mb-3">
                  <Col
                    md={12}
                    lg={12}
                    className="d-flex justify-content-between"
                  >
                    <Button
                      type="button"
                      style={{ marginTop: '21px' }}
                      variant="info"
                      onClick={() => handleFecharContrato()}
                      disabled={
                        loading ||
                        (contrato !== null && contrato !== undefined) ||
                        orcamentoAlterado
                      }
                      className={`${
                        contrato ||
                        !tratamento ||
                        tratamento?.orcamento === false
                          ? 'd-none'
                          : ''
                      }`}
                    >
                      {loading ? (
                        <Spinner>
                          <FaSpinner />
                        </Spinner>
                      ) : (
                        'Fechar Contrato'
                      )}
                    </Button>
                    {contrato && (
                      <>
                        <div>
                          <Link
                            className="btn btn-sm btn-outline-primary py-0"
                            to={`/contratotratamento/${contrato.ConCodigo}`}
                            target="_blank"
                          >
                            <FaPrint />
                          </Link>
                        </div>
                        {/* <div>
                        <Button
                          type="button"
                          style={{ marginTop: '21px' }}
                          variant="info"
                          onClick={() => handleFinalizarTratamento()}
                          disabled={!possoFinalizar}
                          className={`${bloqueado ? 'd-none' : ''}`}
                        >
                          {tratamento?.finalizado
                            ? 'Tratamento Finalizado'
                            : 'Finalizar Tratamento'}
                        </Button>
                      </div> */}
                      </>
                    )}

                    {user.UsuCodigo === 1 && agendamentos.agendas.length === 0 && (
                      <div>
                        <Button
                          type="button"
                          variant="outline-danger"
                          size="sm"
                          data-id={id}
                          onClick={() => handleDelete()}
                        >
                          <FaTrashAlt size={18} />
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
              {tratamento && pacoteSelecionado && contrato && (
                <div className="p-2 border rounded">
                  <AgendamentosTratamento
                    bloqueado
                    idTratamento={tratamento.id}
                    perfilPacote={pacoteSelecionado.PrgPerCodigo}
                    agendamentosIniciais={agendamentos.agendas}
                    secoes={pacoteSelecionado?.PrgLimiteMensal}
                    limite={pacoteSelecionado?.PrgLimiteSemanal}
                    validade={tratamento.validade}
                    valor={tratamento.valor}
                    finalizado={tratamento.finalizado}
                  />
                </div>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default PacoteTratamento;
